import React from 'react';
import { connect } from 'react-redux';
import ConfirmTable from '../components/ConfirmTable';
import { backInputPage, sendContact } from '../actions';

const mapStateToProps = state => ({
  confirmDisplay: state.confirm_page,
  form: state.form,
  requesting: state.isRequesting,
  token: state.token,
  form_settings: state.form_settings
});

const mapDispatchToProps = dispatch => ({
  inputBack: (e) => {
    e.preventDefault();
    dispatch(backInputPage());
  },
  sendContact: (e, token) => {
    e.preventDefault();
    dispatch(sendContact(token));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmTable);
